<template>
  <div class="topbar-item">
    <div
      id="kt_quick_user_toggle"
      class="
        btn btn-icon btn-hover-transparent-white
        d-flex
        align-items-center
        btn-lg
        px-md-2
        w-md-auto
      "
    >
      <span
        class="
          text-white
          opacity-70
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        Hi,
      </span>
      <span
        class="
          text-white
          opacity-90
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-4
        "
      >
        {{ username }}
      </span>
      <button
        class="btn btn-light-primary btn-bold"
        :disabled="logoutLoading"
        @click="onLogout"
      >
        {{ logoutLoading ? "Logging out..." : "Sign out" }}
      </button>
      <div v-if="logoutError" class="text-danger small mt-2">
        {{ logoutError }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import ApiService, {
  clearAuthenticationState,
} from "@/core/services/api.service";
import { API_ENDPOINTS } from "@/core/services/api.endpoints";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning",
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success",
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger",
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info",
        },
      ],
      username: localStorage.getItem("Username"),
      logoutLoading: false,
      logoutError: "",
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    onLogout() {
      if (this.logoutLoading) {
        return;
      }
      this.logoutLoading = true;
      this.logoutError = "";
      ApiService.setHeader();
      ApiService.query(API_ENDPOINTS.auth.logout).then(() => {
        this.$store.dispatch(LOGOUT);
        clearAuthenticationState();
        this.$router.push({ name: "login" });
      }).catch(() => {
        this.logoutError = "Logout failed. Please try again.";
      }).finally(() => {
        this.logoutLoading = false;
      });
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
  },
  computed: {
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    },
  },
};
</script>
